import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  // {
  //   path: "/baseData",
  //   name: authCodeMap.baseData,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/baseData/doctorManage",
  //   meta: {
  //     title: "基础数据",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.baseData,
  //   },
  //   children: [
  //     {
  //       path: "doctorManage",
  //       name: authCodeMap.baseData_doctorManage,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.baseData_doctorManage,
  //       },
  //     },
  //     {
  //       path: "doctor_baseData_doctorManage",
  //       name: authCodeMap.doctor_baseData_doctorManage,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.doctor_baseData_doctorManage,
  //       },
  //     },
  //     {
  //       path: "doctor_baseData_doctorManage_enterprise_add",
  //       name: authCodeMap.doctor_baseData_doctorManage_enterprise_add,
  //       component: (): any => import("@/modules/baseData/pages/doctorManagement/components/enterpriseAddDoctor.vue"),
  //       meta: {
  //         title: "管理_医生管理_添加医生",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.doctor_baseData_doctorManage_add,
  //       },
  //     },
  //     {
  //       path: "baseData_doctorManage_label",
  //       name: authCodeMap.baseData_doctorManage_label,
  //       component: (): any => import("@/modules/baseData/pages/components/label.vue"),
  //       meta: {
  //         title: "管理_标签管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.baseData_doctorManage_label,
  //       },
  //     },
  //     {
  //       path: "doctor_baseData_doctorManage_hospital_add",
  //       name: authCodeMap.doctor_baseData_doctorManage_hospital_add,
  //       component: (): any => import("@/modules/baseData/pages/doctorManagement/components/hospitalAddDoctor.vue"),
  //       meta: {
  //         title: "管理_医生管理_添加医生",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.doctor_baseData_doctorManage_add,
  //       },
  //     },
  //     {
  //       path: "doctor_baseData_doctorManage_info",
  //       name: authCodeMap.doctor_baseData_doctorManage_info,
  //       component: (): any => import("@/modules/baseData/pages/doctorManagement/components/doctorInfo.vue"),
  //       meta: {
  //         title: "管理_医生管理_添加医生",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.doctor_baseData_doctorManage_info,
  //       },
  //     },
  //     // 旧医生管理
  //     {
  //       path: "health_baseData_doctorManage",
  //       name: authCodeMap.health_baseData_doctorManage,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.health_baseData_doctorManage,
  //       },
  //     },
  //     // 新医生管理
  //     {
  //       path: "health_baseData_doctorManageMent",
  //       name: authCodeMap.health_baseData_doctorManageMent,
  //       component: (): any => import("@/modules/baseData/pages/doctorManagement/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: true,
  //         authCode: authCodeMap.health_baseData_doctorManageMent,
  //       },
  //     },
  //     // 新医生管理
  //     {
  //       path: "doctor_baseData_doctorManageMent",
  //       name: authCodeMap.doctor_baseData_doctorManageMent,
  //       component: (): any => import("@/modules/baseData/pages/doctorManagement/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: true,
  //         authCode: authCodeMap.doctor_baseData_doctorManageMent,
  //       },
  //     },
  //     {
  //       path: "old_health_baseData_doctorManage",
  //       name: authCodeMap.health_baseData_doctorManage,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/index.vue"),
  //       meta: {
  //         title: "管理_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.health_baseData_doctorManage,
  //       },
  //     },
  //     {
  //       path: "baseData_doctorManage_distribution",
  //       name: authCodeMap.baseData_doctorManage_distribution,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/agent.vue"),
  //       meta: {
  //         title: "管理_医生_代运营管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.baseData_doctorManage_distribution,
  //       },
  //     },
  //     {
  //       path: "baseData_doctorManage_distribution_health",
  //       name: authCodeMap.baseData_doctorManage_distribution_health,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/agent.vue"),
  //       meta: {
  //         title: "管理_医生_代运营管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.baseData_doctorManage_distribution_health,
  //       },
  //     },
  //     {
  //       path: "baseData_doctorManage_distribution_doctor",
  //       name: authCodeMap.baseData_doctorManage_distribution_doctor,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/agent.vue"),
  //       meta: {
  //         title: "管理_医生_代运营管理",
  //         hidden: true,
  //         needLogin: true,
  //         keepAlive: false,
  //         authCode: authCodeMap.baseData_doctorManage_distribution_doctor,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_doctorManage_dataOverview,
  //       name: authCodeMap.baseData_doctorManage_dataOverview,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/dataOverview.vue"),
  //       meta: {
  //         title: "管理_医生管理_数据分析",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorManage_dataOverview,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_doctorManage_joined,
  //       name: authCodeMap.baseData_doctorManage_joined,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/joined.vue"),
  //       meta: {
  //         title: "管理_医生管理_医生详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorManage_joined,
  //       },
  //     },
  //     {
  //       path: "doctorManage/doctorDetail",
  //       name: authCodeMap.baseData_doctorDetail,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/detail.vue"),
  //       meta: {
  //         title: "管理_医生管理_医生详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorDetail,
  //       },
  //     },
  //     {
  //       path: "doctorManage/addDoctorDetail/detail",
  //       name: authCodeMap.baseData_doctorManage_input_detail,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/components/addDoctorDetail.vue"),
  //       meta: {
  //         title: "管理_医生管理_录入医生查看",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorManage_input_detail,
  //       },
  //     },
  //     {
  //       path: "doctorManage/addDoctorDetail/edit",
  //       name: authCodeMap.baseData_doctorManage_input_edit,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/components/addDoctorEdit.vue"),
  //       meta: {
  //         title: "管理_医生管理_录入医生编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorManage_input_edit,
  //       },
  //     },
  //     {
  //       path: "doctorManage/addDoctorDetail/doctorGoodEdit",
  //       name: authCodeMap.baseData_doctorManage_input_good_edit,
  //       component: (): any => import("@/modules/baseData/pages/doctorManage/components/doctorGoodEdit.vue"),
  //       meta: {
  //         title: "管理_医生管理_录入医生商品编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_doctorManage_input_good_edit,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_userManage_label,
  //       name: authCodeMap.baseData_userManage_label,
  //       component: (): any => import("@/modules/baseData/pages/userManage/userLabel.vue"),
  //       meta: {
  //         title: "资产_用户资产_用户标签",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_userManage_label,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_userManage_user,
  //       name: authCodeMap.baseData_userManage_user,
  //       component: (): any => import("@/modules/baseData/pages/userManage/user.vue"),
  //       meta: {
  //         title: "资产_用户资产_注册用户",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_userManage_user,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_visitManage_visit,
  //       name: authCodeMap.baseData_visitManage_visit,
  //       component: (): any => import("@/modules/baseData/pages/visitManage/index.vue"),
  //       meta: {
  //         title: "资产_用户资产_就诊用户",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_visitManage_visit,
  //       },
  //     },
  //     {
  //       path: authCodeMap.baseData_userManage_tourist,
  //       name: authCodeMap.baseData_userManage_tourist,
  //       component: (): any => import("@/modules/baseData/pages/userManage/tourist.vue"),
  //       meta: {
  //         title: "资产_用户资产_普通用户",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_userManage_tourist,
  //       },
  //     },
  //     // {
  //     //   path: "userManage",
  //     //   name: authCodeMap.baseData_userManage,
  //     //   component: (): any => import("@/modules/baseData/pages/userManage/index.vue"),
  //     //   meta: {
  //     //     title: "基础数据_用户管理",
  //     //     hidden: true,
  //     //     needLogin: true,
  //     //     authCode: authCodeMap.baseData_userManage,
  //     //   },
  //     // },
  //     {
  //       path: "organizationManage",
  //       name: authCodeMap.baseData_organizationManage,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/index.vue"),
  //       meta: {
  //         title: "运营_推荐社区",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationManage,
  //       },
  //     },
  //     {
  //       path: "organizationManage/organizationEdit",
  //       name: authCodeMap.baseData_organizationEdit,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/edit.vue"),
  //       meta: {
  //         title: "营销_推荐机构_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationEdit,
  //       },
  //     },
  //     {
  //       path: "organizationManage/organizationActiveManage",
  //       name: authCodeMap.baseData_organizationActiveManage,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/activeManage.vue"),
  //       meta: {
  //         title: "营销_推荐机构_活动管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationActiveManage,
  //       },
  //     },
  //     {
  //       path: "organizationManage/organizationDoctorManage",
  //       name: authCodeMap.baseData_organizationDoctorManage,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/doctorManage.vue"),
  //       meta: {
  //         title: "营销_推荐机构_医生管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationDoctorManage,
  //       },
  //     },
  //     {
  //       path: "organizationManage/organizationDetails",
  //       name: authCodeMap.baseData_organizationDetails,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/details.vue"),
  //       meta: {
  //         title: "营销_推荐机构_详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationDetails,
  //       },
  //     },
  //     {
  //       path: "vest",
  //       name: authCodeMap.baseData_organizationDetails_vest,
  //       component: (): any => import("@/modules/baseData/pages/organizationManage/vest.vue"),
  //       meta: {
  //         title: "马甲管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.baseData_organizationDetails_vest,
  //       },
  //     },
  //   ],
  // },
];
export default routes;
